import {
    FeedbackFormFields,
} from 'app/shared-components/BatchActions/components/UploadFeedback/UploadFeedback.types'
import {
    ForecastCreatePreparedData,
} from './ShortTermForecastCsvUpload.types'

const feedbackFormFields: FeedbackFormFields<ForecastCreatePreparedData> = [{
    title: '',
    fields: [
        {
            name: 'selectedRecords',
            labelKey: 'RECORDS_TOTAL',
            componentName: 'InputSingleline',
            disabled: true,
        },
        {
            name: 'updatedRecords',
            labelKey: 'UPLOADED_RECORDS',
            componentName: 'InputSingleline',
            disabled: true,
        },
        {
            name: 'failedRecords',
            labelKey: 'ERRORS',
            componentName: 'InputSingleline',
            disabled: true,
        },
    ],
}]

export default feedbackFormFields
